import React, { useState } from "react";
import { useQueryState, parseAsInteger } from "nuqs";
import { ISubAdminPayload } from "../../../types/api/subAdmin";
import { useSubAdminList, useSubAdminUpdate } from "../../../hooks/api/subAdmin/hooks";
import { SubAdminPanel } from "./SubAdminPanel";
import SubAdminModal from "./SubAdminModal";
import { useMessageApi } from "../../../provider/AntdNotification";

const SubAdminList: React.FC = () => {
  const messageApi = useMessageApi();
  const [search, setSearch] = useQueryState("search", { defaultValue: "" });
  const [page, setPage] = useQueryState("page", parseAsInteger.withDefault(1));
  const [limit, setLimit] = useQueryState("limit", parseAsInteger.withDefault(10));

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<ISubAdminPayload | null>(null);

  const queryData = {
    page,
    limit,
    name: search || undefined,
  };

  const { data, isLoading, isError } = useSubAdminList(queryData);

  const statusMutation = useSubAdminUpdate({
    onSuccess: () => messageApi.success("Status updated"),
    onError: (err: any) =>
      messageApi.error(err?.response?.data?.message || err?.message || "Failed to update status"),
  });

  const handleAdd = () => {
    setSelectedItem(null);
    setModalOpen(true);
  };

  const handleEdit = (record: ISubAdminPayload) => {
    setSelectedItem(record);
    setModalOpen(true);
  };

  const handleToggleStatus = (record: ISubAdminPayload) => {
    statusMutation.mutate({ id: record._id!, data: { status: !record.status } });
  };

  return (
    <div className="w-full">
      <SubAdminPanel
        list={data?.data || []}
        total={data?.extra?.total || 0}
        loading={isLoading}
        isError={isError}
        queryData={queryData}
        search={search}
        onSearchChange={setSearch}
        onPageChange={(newPage, newLimit) => {
          if (newLimit !== limit) {
            setLimit(newLimit);
            setPage(1);
          } else {
            setPage(newPage);
          }
        }}
        onAdd={handleAdd}
        onEdit={handleEdit}
        onToggleStatus={handleToggleStatus}
      />

      <SubAdminModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        selectedItem={selectedItem}
      />
    </div>
  );
};

export default SubAdminList;
